import React from 'react';
import { useMutation } from '@apollo/client/react';
import { ModalTypography } from 'components/styles_components/typography';
import { FormattedMessage } from 'react-intl';
import { useError } from 'contexts/error';
import UpsertMutation from 'mutations/billing_details/upsert';
import Form from 'components/space/billing_details/form';

const Create = ({ handleClose, onSuccess }) => {
  const setError = useError();
  const [upsertMutation, { loading }] = useMutation(UpsertMutation, {
    onCompleted: ({ upsertBillingDetails }) => {
      onSuccess(upsertBillingDetails.billingDetails);
    },
    onError: () => {
      setError('error.billing_details.create');
    },
  });

  return (
    <>
      <ModalTypography variant="h5" align="center">
        <FormattedMessage id="header.billing_details.create" />
      </ModalTypography>
      <Form
        initialValues={{
          name: '',
          address: '',
          city: '',
          zipCode: '',
          taxId: '',
          email: '',
        }}
        processing={loading}
        onSubmit={(values) => upsertMutation({ variables: values })}
        onCancel={handleClose}
      />
    </>
  );
};

export default Create;
